import { WebGLRenderer } from 'three';

let defaultRenderer: WebGLRenderer | null = null;

export function getDefaultRenderer(): WebGLRenderer | null {
  if (defaultRenderer) return defaultRenderer;

  // Skip in SSR / non-DOM environments
  if (typeof window === 'undefined') return null;

  try {
    // Prefer OffscreenCanvas if available
    const canvas: HTMLCanvasElement | OffscreenCanvas =
      typeof OffscreenCanvas !== 'undefined'
        ? new OffscreenCanvas(1, 1)
        : (() => {
            const c = document.createElement('canvas');
            // No need to attach to DOM; Three works with a detached canvas
            c.width = 1;
            c.height = 1;
            return c;
          })();

    defaultRenderer = new WebGLRenderer({
      canvas: canvas as any,
      antialias: false,
      alpha: true,
      powerPreference: 'high-performance',
      preserveDrawingBuffer: false,
    });

    defaultRenderer.setPixelRatio(1);
    defaultRenderer.setSize(1, 1, false);

    return defaultRenderer;
  } catch {
    // If context creation fails, fall back to null (preload will just skip detectSupport)
    return null;
  }
}

export function disposeDefaultRenderer() {
  if (defaultRenderer) {
    defaultRenderer.dispose();
    defaultRenderer = null;
  }
}
